import { Box } from "@mui/material";
import React from "react";

function MUIBox({ children, ...props }) {
  const { sx, ...rest } = props;

  return (
    <Box
      {...rest}
      sx={{
        width: "100%",
        minHeight: "100vh",
        bgcolor: "#F8F8F8",
        px: { xs: 1, sm: 2, md: 3 },
        ...sx, // ✅ override / extend styles
      }}
    >
      <Box
        sx={{
          maxWidth: { xs: "100%", md: 1200, lg: 1320 },
          mx: "auto",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default MUIBox;
